
export class ModelValueCopyPaste {

  /**
   * Gets or sets the deal type identifier from where we are copying from.
   */
  copyFromDealTypeId?: string | null = null;

  /**
   * Gets or sets the deal group identifier from where we are copying from.
   */
  copyFromDealGroupId?: string | null = null;

  /**
   * Descriptive name of the model source
   */
  copyFromModelSource?: string | null = null;

  /**
   * Gets or sets the deal type identifier from where we are copying to.
   */
  copyToDealTypeId?: string | null = null;

  /**
   * Gets or sets the deal group identifier from where we are copying from.
   */
  copyToDealGroupId?: string | null = null;

  /**
   * Descriptive name of the model target destination
   */
  copyToModelDestination?: string | null = null;

  /**
   * Gets or sets the model value identifier from where we are copying from.
   */
  copyModelValueBranchId?: string | null = null;

  /**
   * Descriptive name of the model branch that we are copying from
   */
  copyModelValue?: string | null = null;

  /**
   * Gets or sets the model value identifier from where we are copying to can be null for top level.
   */
  copyToModelValueBranchId?: string | null = null;

  /**
   * Descriptive name of the model destination branch that we are copying to
   */
  copyToModelValue?: string | null = null;
}
